import { Component } from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import { validateExperimentName, validateExperimentDescription } from "helpers/experiments"
import { Button, DialogActions, DialogContent, FormControl, TextField } from "@mui/material"
import "./style.scss"

function computeDisabledButton({ name, errors }) {
  return !name || errors.descriptionError || errors.nameError
}
class SaveForm extends Component {
  static propTypes = {
    submitLabel: PropTypes.string,
    close: PropTypes.func,
    save: PropTypes.func.isRequired,
    experiment: PropTypes.object.isRequired,
  }

  constructor(props, ...args) {
    super(props, ...args)
    const currentName = get(this.props, "experiment.name", "")
    const errors = {}
    const state = {
      name: currentName,
      description: get(this.props, "experiment.description", ""),
    }

    if (state.name && !validateExperimentName(state.name)) {
      errors.name = true
    }

    if (state.description && !validateExperimentDescription(state.description)) {
      errors.description = true
    }

    this.state = { ...state, errors, submitDisabled: !currentName || errors.description || errors.name }
  }

  setName = event => {
    const { value } = event.target
    const changes = {
      errors: { ...this.state.errors },
    }

    if (!validateExperimentName(value) && !changes.errors.nameError) {
      changes.errors.nameError = true
    } else if (validateExperimentName(value) && changes.errors.nameError) {
      changes.errors.nameError = false
    }

    changes.name = value

    const newState = { ...this.state, ...changes }
    newState.submitDisabled = computeDisabledButton(newState)
    this.setState(newState)
  }

  setDescription = event => {
    const { value } = event.target
    const changes = {
      errors: { ...this.state.errors },
    }

    if (!validateExperimentDescription(value) && !changes.errors.descriptionError) {
      changes.errors.descriptionError = true
    } else if (validateExperimentDescription(value) && changes.errors.descriptionError) {
      changes.errors.descriptionError = false
    }

    changes.description = value

    const newState = { ...this.state, ...changes }
    newState.submitDisabled = computeDisabledButton(newState)
    this.setState(newState)
  }

  save = () => {
    const { save } = this.props
    const { name, description } = this.state
    const newState = { ...this.state, submitDisabled: true }
    this.setState(newState)
    save(name, description)
  }

  onKeyPress = (event) => {
    const { name, description } = this.state
    if (event.key === "Enter") {
      if (!event.shiftKey) {
        event.preventDefault()
        if (validateExperimentDescription(description) && validateExperimentName(name)) {
          this.save()
        }
      }
    }
  }

  render() {
    const { name, description, errors, submitDisabled } = this.state
    const { close, submitLabel } = this.props

    return <>
      <DialogContent className="modules_save-experiment_components_save-form">
        <FormControl variant="standard" className="experiment-name-input-wrapper">
          <TextField
            variant="standard"
            label="Name"
            value={name}
            error={errors.nameError}
            onChange={this.setName}
            onKeyDown={this.onKeyPress}
            autoFocus
            helperText={errors.nameError ? "Invalid name. Please follow naming guidelines." : "3-50 chars long. Alphanum, _, -, and spaces."}
            slotProps={{
              formHelperText: { error: errors.nameError },
            }}
          />
        </FormControl>
        <FormControl variant="standard" className="experiment-description-input-wrapper">
          <TextField
            variant="standard"
            label="Description"
            multiline
            value={description}
            error={errors.descriptionError}
            onKeyDown={this.onKeyPress}
            onChange={this.setDescription}
            helperText={errors.descriptionError ? "Invalid description. Please follow description guidelines." : "280 chars max."}
            slotProps={{
              formHelperText: { error: errors.descriptionError },
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" disabled={submitDisabled} onClick={this.save}>{submitLabel || "Save experiment"}</Button>
      </DialogActions>
    </>
  }
}

export default SaveForm
